/* A2M unified Enthusiast cart completion offer V4.
   Replaces assets/a2m-bundle-cart-offer.js (do not load V3 alongside this file).
   The gifts controller adds freechain gifts; this script adds ONLY the second tee.
*/
(()=>{'use strict';
 if(window.__a2mCartOfferV2)return;window.__a2mCartOfferV2=true;
 // Load the established A2M thin-arrow font independently from the cart drawer.
 // This upsell also renders on the full cart page and must not depend on drawer JS.
 if(!document.getElementById('a2m-enthusiast-arrow-style')){
   const arrowStyle=document.createElement('style');
   arrowStyle.id='a2m-enthusiast-arrow-style';
   arrowStyle.textContent='@font-face{font-family:A2MCartThinArrow;src:url("https://cdn.shopify.com/s/files/1/0762/2403/7122/files/sf-pro-display-thin.otf?v=1792479370") format("opentype");font-weight:100;font-display:swap}.a2m-cart-bundle-offer .a2m-cart-sf-arrow{font-family:A2MCartThinArrow,"Helvetica Neue",Arial,sans-serif!important;font-weight:100!important;font-size:1.15em;line-height:1;display:inline-block;margin-left:12px;vertical-align:-.02em}';
   document.head.append(arrowStyle);
 }
 const configEl=document.getElementById('a2m-cart-bundle-config');if(!configEl)return;
 let cfg={};try{cfg=JSON.parse(configEl.textContent||'{}')}catch{return}
 const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
 const productCache=new Map();let busy=false,serial=0,refreshTimer;
 const name=i=>String([i.product_title,i.handle].filter(Boolean).join(' ')).toLowerCase();
 const isTee=i=>/enthusiast/.test(name(i))&&/tee/.test(name(i))&&!/bundle|\+/.test(name(i));
 const eligibleCount=c=>(c.items||[]).filter(isTee).reduce((sum,i)=>sum+Number(i.quantity||0),0);
 // V4.23: Give the existing Melody upgrade priority when both offers qualify.
 // This only controls visibility; it does not modify cart items or discounts.
 function melodyUpgradeTakesPriority(cart){
   const items=cart?.items||[];
   if(eligibleCount(cart)!==1)return false;
   let promo={};try{promo=JSON.parse(document.getElementById('a2m-cart-promo-v44-config')?.textContent||'{}')}catch{}
   const parents=new Set([promo.addicted?.id,promo.fl?.id].map(Number).filter(v=>v>0));
   const live=items.filter(i=>Number(i.quantity)>0);
   const hasThermal=live.some(i=>{
     if(parents.has(Number(i.product_id)))return false;
     if(Number(promo.thermalId)>0&&Number(i.product_id)===Number(promo.thermalId))return true;
     const n=name(i);return /melody/.test(n)&&/thermal/.test(n)&&!n.includes('+')&&!/chain/.test(n);
   });
   if(!hasThermal)return false;
   const hasPass=live.some(i=>/platinum[\s_-]*pass/.test(name(i))||Boolean(i.properties?._a2m_melody_gift)||i.properties?._a2m_enthusiast_auto_gift==='pass');
   // The existing Melody renderer suppresses its offers when a pass exists.
   // Don't hide Enthusiast in that case; a buyer still needs a visible action.
   if(hasPass)return false;
   const hasChain=live.some(i=>{
     if(parents.has(Number(i.product_id)))return false;
     if(Number(promo.addictedChain?.variantId)>0&&Number(i.variant_id)===Number(promo.addictedChain.variantId))return true;
     if(Number(promo.flChain?.variantId)>0&&Number(i.variant_id)===Number(promo.flChain.variantId))return true;
     const n=name(i);return /addicted[\s"“”'_-]*chain|chain[\s"“”'_-]*addicted|\bfl\b[\s"“”'_-]*chain|chain[\s"“”'_-]*\bfl\b/.test(n);
   });
   // V4.28: Priority applies to the MISSING-CHAIN step only.
   // As soon as either chain is in the cart, the 1-of-2 tee offer returns.
   // The independent Melody renderer still handles Thermal + Chain without a tee.
   if(hasChain)return false;
   return [promo.addictedChain,promo.flChain].some(ch=>Number(ch?.variantId)>0);
 }
 const element=(tag,cls='',text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e};
 const getCart=async()=>{const r=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('Unable to read cart');return r.json()};
 const load=handle=>{if(!productCache.has(handle))productCache.set(handle,fetch(root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('Product options unavailable');return r.json()}).catch(e=>{productCache.delete(handle);throw e}));return productCache.get(handle)};
 const variantsFor=v=>Array.isArray(v.options)?v.options:[v.option1,v.option2,v.option3];
 const fullHandle=String(cfg.handle||'enthusiast-tee');
 function babyHandle(){try{const c=JSON.parse(document.getElementById('a2m-cart-promo-v44-config')?.textContent||'{}');return String(c.babyHandle||'enthusiast-baby-tee')}catch{return 'enthusiast-baby-tee'}}
 function panel(mode){
   const section=element('section','a2m-cart-bundle-offer');section.dataset.a2mCartBundleOffer='1';
   const heading=element('div','a2m-cart-bundle-title');heading.append(element('span','','complete your bundle'),element('span','a2m-cart-bundle-badge',cfg.badge||'best value'));
   section.append(heading,element('p','a2m-cart-bundle-caption','buy any 2 enthusiast tees, get your free gifts :)'),element('p','a2m-cart-bundle-small','mix regular and baby tees · choose any artist + size'));
   const fields=element('div','a2m-cart-bundle-selects');section.append(fields);
   const typeField=element('div','a2m-cart-bundle-field'),typeLabel=element('label','','tee style'),style=element('select');style.setAttribute('aria-label','tee style');
   for(const [value,text] of [['regular','enthusiast tee'],['baby','enthusiast baby tee']]){const opt=element('option','',text);opt.value=value;style.append(opt)}
   typeField.append(typeLabel,style);fields.append(typeField);
   const optionArea=element('div','a2m-cart-bundle-selects');section.append(optionArea);
   const button=element('button','a2m-cart-bundle-add');
   button.type='button';button.disabled=true;
   // Reuse the exact thin arrow class already used by A2M's Melody upsell.
   button.append(document.createTextNode('add 1 more tee '));
   const arrow=element('span','a2m-cart-sf-arrow','→');
   arrow.setAttribute('aria-hidden','true');
   button.append(arrow);
   const status=element('p','a2m-cart-bundle-status');status.setAttribute('role','status');section.append(button,status);
   let product=null,selects=[],loadVersion=0;
   function selected(){return product?.variants?.find(v=>v.available&&selects.every((s,i)=>String(variantsFor(v)[i])===s.value))}
   async function changeStyle(){
     const n=++loadVersion;button.disabled=true;status.textContent='';optionArea.replaceChildren();
     try{
       const p=await load(style.value==='baby'?babyHandle():fullHandle);
       if(n!==loadVersion||!section.isConnected)return;
       const options=(p.options||[]).map(o=>typeof o==='string'?o:o.name);
       const artistIndex=options.findIndex(o=>/artist/i.test(o));
       // Custom requires product-page-only text and must not be offered in cart upsells.
       product={...p,variants:(p.variants||[]).filter(v=>{
         if(artistIndex<0)return true;
         const vals=variantsFor(v);
         return String(vals[artistIndex]||'').trim().toLowerCase()!=='custom';
       })};
       const available=(product.variants||[]).filter(v=>v.available);
       if(!available.length)throw Error('Selected tee is sold out');
       selects=options.map((opt,i)=>{
         const g=element('div','a2m-cart-bundle-field'),lab=element('label','',String(opt).toLowerCase()),select=element('select');
         select.setAttribute('aria-label',String(opt));
         const values=[...new Set(available.map(v=>variantsFor(v)[i]).filter(Boolean))];
         for(const v of values){const item=element('option','',/size/i.test(opt)?String(v).toUpperCase():String(v));item.value=v;select.append(item)}
         select.value=String(variantsFor(available[0])[i]);g.append(lab,select);optionArea.append(g);return select;
       });
       selects.forEach((s,i)=>s.addEventListener('change',()=>{
         if(!selected()){
           const match=available.find(v=>String(variantsFor(v)[i])===s.value);
           if(match)selects.forEach((field,j)=>{if(j!==i)field.value=String(variantsFor(match)[j])});
         }
         button.disabled=!selected()||busy;
       }));
       button.disabled=!selected()||busy;
     }catch(e){if(n===loadVersion)status.textContent=e.message||'Unable to load tee variants'}
   }
   style.addEventListener('change',changeStyle);
   button.addEventListener('click',async()=>{
     const v=selected();if(!v||busy)return;busy=true;button.disabled=true;status.textContent='';
     try{
       const now=await getCart();if(eligibleCount(now)!==1)throw Error('Cart changed. Reopen the drawer.');
       const res=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(v.id),quantity:1}]})});
       const data=await res.json().catch(()=>({}));if(!res.ok)throw Error(data.description||'Could not add tee');
       // The unified gift controller sees this mutation and adds chain + Platinum Pass.
       document.dispatchEvent(new CustomEvent('a2m:cart-updated',{detail:{source:'a2m-unified-tee-upsell'}}));
       if(mode==='page')location.reload();
     }catch(e){status.textContent=e.message||'Unable to add tee'}
     finally{busy=false;button.disabled=!selected()}
   });
   queueMicrotask(changeStyle);return section;
 }
 function render(cart,mode){
   if(!Array.isArray(cart?.items))return;
   const parent=mode==='drawer'?document.getElementById('a2m-cart-scroll'):document.querySelector('cart-items.a2m-page-cart #main-cart-items');
   if(!parent)return;
   const previous=parent.querySelector('[data-a2m-cart-bundle-offer]');
   if(eligibleCount(cart)!==1||melodyUpgradeTakesPriority(cart)){previous?.remove();return}
   if(previous)return;
   const offer=panel(mode),rec=parent.querySelector('#a2m-cart-recommendations');
   if(mode==='drawer'&&rec)rec.before(offer);else parent.append(offer);
 }
 async function refresh(){const n=++serial;try{const c=await getCart();if(n===serial){render(c,'drawer');render(c,'page')}}catch{}}
 document.addEventListener('a2m:drawer-rendered',e=>render(e.detail?.cart,'drawer'));
 document.addEventListener('a2m:cart-updated',()=>{clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,160)});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();
